export default "__VITE_ASSET__DntvIIrk__"